import React from 'react';

export const NavigationHeader = ({ 
  segment, 
  segments, 
  onPrevious, 
  onNext,
  previousDisabled,
  nextDisabled
}) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <button
        className="flex items-center gap-2 px-4 py-3 bg-white/60 hover:bg-white border border-white/40 hover:border-white/60 rounded-xl transition-all duration-300 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed group"
        onClick={onPrevious}
        disabled={previousDisabled}
      >
        <svg className="w-5 h-5 text-gray-600 group-hover:text-blue-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        <span className="text-sm font-medium text-gray-700 hidden sm:inline">Previous</span>
        <span className="text-xs text-gray-400 group-hover:text-blue-400 sm:hidden">←</span>
      </button>

      {/* Segment Indicator with Keyboard Hint */}
      <div className="flex flex-col items-center px-4 py-2 bg-white/60 rounded-xl border border-white/40">
        <span className="text-sm font-medium text-gray-700">
          Sentence {segment?.["id"] + 1} of {segments?.length}
        </span>
        <div className="flex items-center gap-3 mt-1">
          <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-xs font-mono text-gray-500 hidden sm:inline-block">← →</kbd>
          <span className="text-xs text-gray-500 hidden sm:inline">to navigate</span>
          <span className="text-xs text-gray-500 sm:hidden">Use arrows</span>
        </div>
      </div>

      <button
        className="flex items-center gap-2 px-4 py-3 bg-white/60 hover:bg-white border border-white/40 hover:border-white/60 rounded-xl transition-all duration-300 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed group"
        onClick={onNext}
        disabled={nextDisabled}
      >
        <span className="text-sm font-medium text-gray-700 hidden sm:inline">Next</span>
        <span className="text-xs text-gray-400 group-hover:text-blue-400 sm:hidden">→</span>
        <svg className="w-5 h-5 text-gray-600 group-hover:text-blue-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};